import React, { useContext } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  Input,
  InputLabel,
} from "@material-ui/core";
import { oKBehaviours } from "../../../config/config";
import { customThemes } from "../../../config/themes";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { ConfigContext } from "../../../contexts/ConfigContext";
import { developOptions } from "../../../config/developOptions";
import { flowDisabledLoan } from "../../../config/flows/flowDisabledLoan";
import { flowWelcomeAndTerms } from "../../../config/flows/flowWelcomeAndTerms";
import { flowBREnabled } from "../../../config/flows/flowBREnabled";
import { flowBRDisabled } from "../../../config/flows/flowBRDisabled";
import { flowCaixabankKnownCustomer } from "../../../config/flows/flowCaixabankKnownCustomer";
import { flowCaixabankUnknownCustomerBREnabled } from "../../../config/flows/flowCaixabankUnknownCustomerBREnabled";
import { flowCaixabankUnknownCustomerBRDisabled } from "../../../config/flows/flowCaixabankUnknownCustomerBRDisabled";
import { flowDefaultByMerchant } from "../../../config/flows/flowsByMerchant/flowDefaultByMerchant";
import { flowClientSideKycSignature } from "../../../config/flows/flowClientSideKycSignature";
import { THEME_NAMES } from "../../../config/themes/config";
import { caixabankFlows } from "../../../config/flows/flowFactory/components/caixabank";
import { upfFlows } from "../../../config/flows/flowFactory/components/upf";
import { defaultFlows } from "../../../config/flows/flowFactory/components/default";
import { videoIdFlows } from "../../../config/flows/flowFactory/components/videoId";

const FILTERED_THEMES = [
  THEME_NAMES.BBVATheme,
  THEME_NAMES.carrefour,
  THEME_NAMES.real_turf,
  THEME_NAMES.uponor,
  THEME_NAMES.citiservi,
];

export default function DevelopOptionsPanel() {
  const {
    state: { flowItem, currentFlow },
    dispatch,
  } = useContext(ProcessContext);

  const configDispatch = useContext(ConfigContext).dispatch;

  const currentModuleObj = currentFlow?.modules?.[flowItem];
  const {
    state: { themeName },
  } = useContext(ConfigContext);
  const [inputThemeValues, setInputThemeValues] = React.useState();
  const handleChangeThemeInput = (event) => {
    setInputThemeValues(event.target.value);
  };

  const allSelectableFlows = [
    flowDisabledLoan,
    flowWelcomeAndTerms,

    flowBREnabled,
    flowBRDisabled,

    flowCaixabankKnownCustomer,
    flowCaixabankUnknownCustomerBREnabled,
    flowCaixabankUnknownCustomerBRDisabled,

    flowDefaultByMerchant,

    flowClientSideKycSignature,
  ];

  const getFlowStructure = (flow) =>
    flow.map((flow) => ({
      flowName: flow.name,
      modules: flow.modules.map((modulesArray) => ({
        modules: modulesArray.id,
        KO: modulesArray.onKO?.id,
      })),
    }));

  const printFlows = () => {
    const simpleFlows = {
      defaultFlows: getFlowStructure(defaultFlows),
      caixabankFlows: getFlowStructure(caixabankFlows),
      upfFlows: getFlowStructure(upfFlows),
      videoIdFlowS: getFlowStructure(videoIdFlows),
    };
    console.log("FLOWS:", simpleFlows);
  };

  return (
    <div className="text-center">
      <div
        className="flux-capacitor"
        style={{
          border: "3px solid #000",
          display: "inline-block",
          margin: "auto",
          borderRadius: "5px",
          padding: "4 4px",
          zIndex: 999999,
          position: "absolute",
          top: "20px",
          left: "10px",
        }}
      >
        <Button onClick={printFlows}>
          <i
            className="material-icons"
            style={{
              verticalAlign: "text-top",
              transform: "rotate(180deg)",
              fontSize: "30px",
            }}
          >
            device_hub
          </i>
        </Button>
        <br />
        <select
          value={allSelectableFlows.findIndex(
            (flow) => flow.name === currentFlow?.name
          )}
          name="flows"
          id="flowSelector"
          onChange={(e) => {
            developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH = true;
            developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES = true;
            developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS = true;
            dispatch({
              type: "UPDATE_PROCESS_CONTEXT",
              payload: {
                currentFlow: allSelectableFlows[e.target.value],
                appStarted: false,
                flowMessage: undefined,
                conditionsToBeInitialModuleInFlowChecked: false,
              },
            });
          }}
        >
          {allSelectableFlows.map((flow, flowNum) => (
            <option key={flow.name} value={flowNum}>
              {flow.name}
            </option>
          ))}
        </select>
        <br />
        <select
          style={{ width: "90%" }}
          value={flowItem || ""}
          name="flowItems"
          id="flowItemSelector"
          onChange={(e) => {
            developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH = true;
            developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES = true;
            developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS = true;
            dispatch({
              type: "UPDATE_PROCESS_CONTEXT",
              payload: {
                flowItem: e.target.value,
                flowItemIsKO: false,
              },
            });
          }}
        >
          {currentFlow?.modules.map((item, itemNum) => (
            <option key={`${item?.id}${itemNum}`} value={itemNum}>
              {itemNum} {item?.id}
            </option>
          ))}
        </select>
        {/*<small>*/}
        {/*  {currentFlow && currentFlow.name} {flowItem}*/}
        {/*</small>*/}
        <br />
        {/*<small>{currentModuleObj && currentModuleObj.id}</small>*/}
        <br />
        {currentModuleObj && (
          <>
            <br />
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch({
                  type:
                    currentModuleObj.onOK === oKBehaviours.REPEAT
                      ? "RESET_MODULE_KO"
                      : "SET_FLOW_ITEM_OK",
                });
              }}
            >
              OK
            </Button>{" "}
            <Button
              variant="contained"
              color="secondary"
              disabled={!currentModuleObj.onKO}
              onClick={() =>
                dispatch({
                  type: "SET_MODULE_KO",
                })
              }
            >
              KO
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() =>
                dispatch({
                  type: "SET_MODULE_SKIPPED",
                })
              }
            >
              SKIP
            </Button>
            <Box m={2}>
              <FormControl variant="standard">
                <InputLabel>
                  <small>
                    {inputThemeValues ? "Set " : "Customize "} Theme
                  </small>
                </InputLabel>
                <Input
                  value={inputThemeValues}
                  id="theme-customizer"
                  onChange={handleChangeThemeInput}
                  endAdornment={
                    <IconButton
                      onClick={(e) => {
                        if (inputThemeValues) {
                          configDispatch({
                            type: "CHANGE_THEME",
                            payload: JSON.parse(inputThemeValues),
                          });
                          setInputThemeValues("");
                        } else {
                          navigator.clipboard.writeText(
                            JSON.stringify(customThemes[themeName])
                          );
                        }
                      }}
                    >
                      <i
                        className="material-icons-outlined"
                        style={{ fontSize: 20 }}
                      >
                        {inputThemeValues ? "keyboard_return" : "content_copy"}
                      </i>
                    </IconButton>
                  }
                />
              </FormControl>
              <br />
              <select
                style={{ width: "100%" }}
                value={themeName || ""}
                name="themes"
                id="themeSelector"
                onChange={(e) => {
                  configDispatch({
                    type: "CHANGE_THEME",
                    payload: customThemes[e.target.value],
                  });
                }}
              >
                {Object.keys(customThemes)
                  .filter((theme) => !FILTERED_THEMES.includes(theme))
                  .map((themeName) => (
                    <option key={themeName} value={themeName}>
                      {themeName}
                    </option>
                  ))}
              </select>
            </Box>
            <Box mr={2} textAlign={"left"}>
              <Checkbox
                checked={developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH}
                onChange={(e) => {
                  configDispatch({
                    type: "UPDATE_CONFIG_CONTEXT",
                    payload: {
                      forceUpdate: Date.now(),
                    },
                  });
                  developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH =
                    e.target.checked;
                }}
              />
              FAKE POST/PATCH
              <br />
              <Checkbox
                checked={
                  developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS
                }
                onChange={(e) => {
                  configDispatch({
                    type: "UPDATE_CONFIG_CONTEXT",
                    payload: {
                      forceUpdate: Date.now(),
                    },
                  });
                  developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS =
                    e.target.checked;
                }}
              />
              FAKE RESPONSES
              <br />
              <Checkbox
                checked={developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES}
                onChange={(e) => {
                  configDispatch({
                    type: "UPDATE_CONFIG_CONTEXT",
                    payload: {
                      forceUpdate: Date.now(),
                    },
                  });
                  developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES =
                    e.target.checked;
                }}
              />
              FAKE DEFAULT FORMS
            </Box>
          </>
        )}
      </div>
    </div>
  );
}
